import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { MessagingEnvironmentService } from '../../../core/services/messaging-environment.service';

@Injectable()
export class MessagingTranslationService {
  constructor(private translate: TranslateService, private http: HttpClient, private env: MessagingEnvironmentService) {
    this.getTranslations();
    this.setTranslationsSubscription();
  }

  setTranslationsSubscription(): void {
    this.translate.onTranslationChange.subscribe(() => {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      const translation = this.translate.translations[this.translate.currentLang];
      if (!translation['NGX-MESSAGING']) {
        this.getTranslations();
      }
    });
  }

  getTranslations(): void {
    this.http.get(`${this.env.env.assetsNgxMessaging}/i18n/${this.translate.currentLang}.json`).subscribe((translations) => {
      this.translate.setTranslation(this.translate.currentLang, translations, true);
    });
  }
}
